import { baseUrl } from '@/config/env';
import request from '@/router/axios';
import { parseParam } from '@/util/util';

export const findUnfreezeApply= (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-wallet/v1/unfreezeApply?`+params,
        method: 'GET'
    })
}

export const updateUnfreezeApply = (id,data) => {
    data = parseParam(data)
    return request({
        url: `${baseUrl}/joins-wallet/v1/unfreezeApply/${id}?`+data,
        method: 'PUT'
    })
}
export const pass = (id) => {
    return request({
        url: `${baseUrl}/joins-wallet/v1/unfreezeApply/pass/${id}`,
        method: 'PUT'
    })
}
export const refused = (id,reason) => {
    return request({
        url: `${baseUrl}/joins-wallet/v1/unfreezeApply/refused/${id}?reason=`+reason,
        method: 'PUT'
    })
}